export const APP_LINKS = {
  GOOGLE_FORMS_FEEDBACK: 'https://forms.gle/a9YJwos2tC9bDS728',
};
